import { FC, ReactNode } from 'react';
import CustomButton, { ButtonType } from 'components/custom-button/CustomButton';
import { CustomPopover } from 'components';
import { EditTableIcon, ExportIcon } from 'assets/icons';
import { PopoverArrowTypes } from 'constants/common';

interface ReceiptsTableActionsProps {
  onExportClick: () => void;
  onEditTableClick: () => void;
  isExportPopoverOpen: boolean;
  onCloseExportPopover: () => void;
  exportMenu: ReactNode;
}

const ReceiptsTableActions: FC<ReceiptsTableActionsProps> = ({
  onExportClick,
  onEditTableClick,
  isExportPopoverOpen,
  onCloseExportPopover,
  exportMenu
}) => {
  return (
    <div className="flex w-full items-center justify-end gap-4">
      <CustomPopover
        show={isExportPopoverOpen}
        anchorComponent={() => (
          <CustomButton
            id="export-receipts-button"
            aria-label="Export receipts"
            StartIcon={ExportIcon}
            startIconStyle="path-fill-current text-primaryText"
            type={ButtonType.SECONDARY}
            className="h-8 border border-gray-1 bg-transparent py-1.5 px-3 text-sbase font-semibold
             text-primaryText focus:outline-none focus:ring-2 focus:ring-primary">
            <span className="text-sbase font-medium">Export</span>
          </CustomButton>
        )}
        anchorComponentId="export-receipts-button"
        onTogglePopover={onExportClick}
        onClosePopover={onCloseExportPopover}
        offset="right-0 top-4"
        highlightAnchor={false}
        minWidth="min-w-[160px]"
        showArrow={true}
        arrowType={PopoverArrowTypes.TOP}
        margin="mt-8"
        popoverBodyStyle="p-2">
        {exportMenu}
      </CustomPopover>

      <CustomButton
        id="edit-receipts-table-button"
        aria-label="Edit table"
        StartIcon={EditTableIcon}
        startIconStyle="path-fill-current text-primaryText"
        type={ButtonType.SECONDARY}
        className="h-8 border border-gray-1 bg-transparent py-2 px-3 text-sbase font-semibold
         text-primaryText focus:outline-none focus:ring-2 focus:ring-primary"
        onClick={onEditTableClick}>
        <span className="text-sbase font-medium">Edit table</span>
      </CustomButton>
    </div>
  );
};

export default ReceiptsTableActions;
